export default __webpack_public_path__ + "static/media/case5.d287f6ea.jpg";